<template>
  <div class="w-full min-h-screen flex items-center">
    <div class="max-w-[800px] w-full mx-auto items-center">
      <Card>
        <template #title> </template>
        <CardTitle>
          <h1
            class="mt-10 mb-5 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900 dark:text-white"
          >
            {{ $t(`authentication.${view}`) }}
          </h1>
        </CardTitle>
        <!-- <template #subtitle> Card subtitle </template> -->
        <CardContent>
          <Authentication @update:view="handleUpdateView" :view="view" />
        </CardContent>
      </Card>
    </div>
  </div>
</template>

<script setup lang="ts">
const user = useSupabaseUser();

const view = ref("sign_in");

const route = useRoute();

const { t } = useI18n();
const title = computed(() => {
  return t(`authentication.${view.value}`) + " | DownSub";
});
useHead({
  title: title,
});

definePageMeta({
  layout: "home",
});

watch(user, (newUser) => {
  if (newUser) {
    navigateTo("/dashboard");
  }
});

onBeforeMount(() => {
  if (route.query.view) {
    view.value = route.query.view as string;
  }
});

onMounted(() => {
  if (user.value) {
    navigateTo("/dashboard");
  }
});
const handleUpdateView = (newView: string) => {
  view.value = newView;
};
</script>

<style scoped></style>
